import { Injectable, inject } from '@angular/core';
import { BsApiService } from '@brightside-web/desktop/data-access/core-services';
import { Observable, map } from 'rxjs';
import { PayrollResponse, PayrollResponsePayload } from './payroll.model';

@Injectable({ providedIn: 'root' })
export class PayrollService {
  private _bsApi: BsApiService = inject(BsApiService);

  getPayrollSchedule(): Observable<PayrollResponse> {
    return this._bsApi.get<PayrollResponsePayload>('api-mobile', '/payroll').pipe(map((res) => res.payload));
  }
}
